// constant
import { INSTANCE_URL } from "@constant";
import { postRequest } from "@network";

export const getBadge = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public`;
  let body = { ...data, type: "badges" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
};
